// extracted by mini-css-extract-plugin
module.exports = {"selectboxFilterWrapper":"CompartmentFilter_selectboxFilterWrapper__2i6Lv"};